import React, { useState } from "react";
import styles from "./RefinanceForm.module.css";

function Income({ formData, setFormData, nextStep, prevStep }) {
  const [submitted, setSubmitted] = useState(false);

  // Format displayed currency with commas
  const formatCurrency = (value) => {
    if (!value) return "";
    let num = value.toString().replace(/[^0-9]/g, "");
    return num ? parseInt(num, 10).toLocaleString("en-AU") : "";
  };

  const parseCurrency = (value) => {
    return value ? value.toString().replace(/[^0-9]/g, "") : "";
  };

  const handleChange = (field, value, applicant = "applicant1") => {
    setFormData({
      ...formData,
      [applicant]: {
        ...(formData[applicant] || {}),
        [field]: value,
      },
    });
  };

  const handleIncomeChange = (e, applicant = "applicant1") => {
    const raw = e.target.value;
    const parsed = parseCurrency(raw);
    handleChange("income", parsed, applicant);
  };

  // Validation
  const validateApplicantIncome = (applicant) => {
    const data = formData[applicant] || {};
    const employmentTypeValid = !!data.employmentType;
    const incomeValid =
      !!data.income && !isNaN(parseCurrency(data.income)) && Number(data.income) > 0;
    return { employmentType: employmentTypeValid, income: incomeValid };
  };

  const applicant1Valid = validateApplicantIncome("applicant1");
  const applicant2Valid =
    formData.refinancingWithSomeone === true
      ? validateApplicantIncome("applicant2")
      : { employmentType: true, income: true };

  const isFormValid =
    Object.values(applicant1Valid).every(Boolean) &&
    Object.values(applicant2Valid).every(Boolean);

  const handleNext = () => {
    setSubmitted(true);
    if (isFormValid) nextStep();
  };

  const renderApplicant = (applicantKey, label) => {
    const data = formData[applicantKey] || {};
    const valid = validateApplicantIncome(applicantKey);

    return (
      <div className={styles.formRow}>
        <h4>{label}</h4>

        {/* Employment Type */}
        <select
          className={`${styles.selectField} ${
            submitted && !valid.employmentType ? styles.errorInput : ""
          }`}
          value={data.employmentType || ""}
          onChange={(e) =>
            handleChange("employmentType", e.target.value, applicantKey)
          }
        >
          <option value="">Select Employment Type</option>
          <option value="PAYG">PAYG</option>
          <option value="Self-Employed">Self-Employed</option>
          <option value="Contractor">Contractor</option>
        </select>
        {submitted && !valid.employmentType && (
          <span className={styles.errorText}>Employment type is required</span>
        )}

        {/* Income */}
        <div
          className={`${styles.currencyInput} ${
            submitted && !valid.income ? styles.errorInput : ""
          }`}
        >
          <span className={styles.prefix}>$</span>
          <input
            type="text"
            placeholder="e.g. 85,000"
            value={formatCurrency(data.income)}
            onChange={(e) => handleIncomeChange(e, applicantKey)}
          />
        </div>
        {submitted && !valid.income && (
          <span className={styles.errorText}>Please enter valid income</span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <h3>Income</h3>
      {renderApplicant("applicant1", "Applicant 1")}

      {formData.refinancingWithSomeone === true &&
        renderApplicant("applicant2", "Applicant 2")}

      {/* Navigation */}
      <div className={styles.navBtns}>
        <button type="button" onClick={prevStep}>
          ← Back
        </button>
        <button
          type="button"
          className={styles.nextBtn}
          onClick={handleNext}
          disabled={!isFormValid && submitted}
        >
          Next →
        </button>
      </div>

      {submitted && !isFormValid && (
        <p className={styles.error}>
          ⚠️ Please complete all required fields before continuing.
        </p>
      )}
    </div>
  );
}

export default Income;
